<template>
  <v-ons-page class="ja-content-detail page">
    <div class="page__background" style="background-color: white" />
    <common-header>
      <template #header>
        <Button
          modifier="quiet"
          class="header-back-button"
          @click="router.back()"
          v-show="!isEditing"
        >
          <v-ons-icon icon="md-chevron-left" />
        </Button>
        <span>コンテンツの{{ isEditing ? '編集' : '詳細' }}</span>
      </template>
    </common-header>
    <div class="content-detail-area">
      <!-- 簡易プレビュー -->
      <ja-content-preview
        class="preview-area"
        :key="isEditing"
        :processNum="CREATE_CONTENT_PROCESS_NUM.CONTENT_CONFIRM"
        :templateId="contentDetail.templateId"
        :contentMaterialList="editingContentMaterialList"
        :contentCaption="editingNote"
        :contentCaptionColor="editingCaptionColor"
        :clickMaterial="clickMaterial"
        :isEditing="isEditing"
        :contentFrame="editingFrame"
        :isAudioButtonVisible="true"
      />
      <p class="preview-description" v-show="isEditing">調整したい領域をタップしてください</p>
      <!-- プレビュー領域 -->
      <div class="content-element-area">
        <content-preview-button
          class="content-preview-button"
          @click="showIsFullScreenPreviewMode"
        />
      </div>

      <!-- フレーム領域 -->
      <div class="content-element-area" v-if="HORIZONTAL_TEMPLATES[templateId]">
        <!-- フレーム選択領域 -->
        <ja-content-frame
          :initialSelectedContentFrame="contentFrame"
          :showMoreFrame="showMoreFrame"
          :isEditing="isEditing"
          @selectFrame="handleSelectFrame"
        />
      </div>

      <!-- テロップ領域 -->
      <div v-if="contentDetail.contentCaption || isEditing" class="content-element-area">
        <v-ons-row>
          <v-ons-col><label>テロップ</label></v-ons-col>
        </v-ons-row>
        <!-- テロップ表示 -->
        <p v-show="!isEditing" class="content-caption-detail-area">{{ editingNote }}</p>
        <!-- テロップ編集領域 -->
        <p v-show="isEditing" class="content-caption-area">
          <label class="edit-caption-label" for="edit-caption" />
          <textarea
            type="text"
            name="edit-caption"
            class="text-area"
            id="edit-caption"
            v-model="editingNote"
            placeholder="テロップを入れて、文字色を選択してください (未入力可)"
            maxlength="200"
          />
        </p>
        <!-- テロップ文字数 -->
        <div v-show="isEditing">
          <v-ons-col class="caption-count">
            <p>{{ calcLength() }}/200</p>
          </v-ons-col>
        </div>
        <!-- 文字色選択領域 リファクタが必要 -->
        <div :class="['ja-content-caption-color-area', { isNotEditting: !isEditing }]">
          <p :class="['caption-color-label', { isEditting: isEditing }]">文字色：</p>
          <button
            v-for="(color, key) in CONTENT_CAPTION_COLOR"
            :key="key"
            :class="[
              'button ja-content-caption-color-cell',
              { isSelected: color === contentCaptionColor },
              { unSelectColor: color !== editingCaptionColor && !isEditing },
              { isNotEditting: !isEditing },
            ]"
            :style="{ backgroundColor: color }"
            @click="selectContentCaptionColor(color)"
          ></button>
        </div>
      </div>

      <!-- テロップ読み上げ領域 -->
      <div class="content-element-area">
        <label>テロップの読み上げ</label>
        <toggle-switch
          :value="isCaptionSpeech"
          @input="changeIsCaptionSpeech"
          :disabled="!isEditing"
        />
      </div>

      <!-- テンプレート領域 -->
      <div v-if="contentDetail.templateId" class="content-element-area">
        <label>テンプレート</label>
        <v-ons-row>
          <v-ons-col width="100%">
            <div class="template-element-size">
              <p class="template-title">{{ TEMPLATES[contentDetail.templateId].TITLE }}</p>
              <p class="template-description">
                {{ TEMPLATES[contentDetail.templateId].DESCRIPTION }}
              </p>
            </div>
          </v-ons-col>
        </v-ons-row>
      </div>
    </div>
    <div class="canvas">
      <canvas id="canvas" width="0" height="0"></canvas>
    </div>
    <!-- フッター領域(編集する) -->
    <common-footer class="common-footer d-flex" v-show="!isEditing"
      ><template #footer>
        <v-ons-row class="footer-button-area">
          <small-button
            class="footer-button footer-next-button"
            title="編集する"
            @click="showEditMode"
          />
        </v-ons-row>
      </template>
    </common-footer>

    <!-- フッター領域(キャンセル・保存) -->
    <common-footer class="common-footer d-flex" v-show="isEditing">
      <template #footer>
        <v-ons-row class="footer-button-area">
          <small-button
            class="footer-back-button"
            title="キャンセル"
            :disabled="false"
            @click="moveContentDetail"
          />
          <small-button
            class="footer-upload-button"
            title="保存する"
            :disabled="isSaveButtonDisable"
            @click="contentUpload"
          />
        </v-ons-row>
      </template>
    </common-footer>

    <!-- 全画面プレビュー -->
    <v-ons-modal
      :key="isEditing"
      :visible="isFullScreenPreviewMode"
      id="content-preview-full-screen-modal"
      class="modal-wrapper p-fixed"
    >
      <button class="modal-close-mask" @click="showIsFullScreenPreviewMode" />
      <div class="modal-close-button-area">
        <Button class="modal-close-button" @click="showIsFullScreenPreviewMode">
          <v-ons-icon class="modal-close-icon" icon="fa-close" />
        </Button>
      </div>
      <ja-content-preview
        class="preview-area"
        :processNum="CREATE_CONTENT_PROCESS_NUM.CONTENT_CONFIRM"
        :isFullScreenPreviewMode="true"
        :isVisible="isFullScreenPreviewMode"
        :templateId="contentDetail.templateId"
        :contentMaterialList="editingContentMaterialList"
        :contentCaption="editingNote"
        :contentCaptionColor="editingCaptionColor"
        :timestamp="timestamp"
        :isEditing="isEditing"
        :contentFrame="editingFrame"
      />
    </v-ons-modal>
  </v-ons-page>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import axios from '@/composable/axios';
import SmallButton from '@/components/common/SmallButton.vue';
import ToggleSwitch from '@/components/common/ToggleSwitch.vue';
import ContentPreviewButton from '@/components/common/ContentPreviewButton.vue';
import CommonHeader from '@/components/common/CommonHeader.vue';
import CommonFooter from '@/components/common/CommonFooter.vue';
import JaContentPreview from '@/components/JaContent/JaContentPreview.vue';
import JaContentFrame from '@/components/JaContent/JaContentFrame.vue';
import { dataFetchContentDetail } from '@/composable/data_fetch_common';
import {
  disableScroll,
  enableScroll,
  createUuid,
  handleAxiosCommonException,
  checkNetwork,
} from '@/composable/common';
import { createContentCaptionPng } from '@/composable/content_common';
import { onsNotification, onsConfirm } from '@/composable/onsen_common';
import {
  deleteContentCaptionPngBlobStorage,
  uploadContentCaptionPngBlobStorage,
} from '@/composable/externalServiceCommon';
import {
  CREATE_CONTENT_PROCESS_NUM,
  HORIZONTAL_TEMPLATES,
  CONTENT_CAPTION_COLOR,
  TEMPLATES,
} from '@/composable/constant_common';
import Button from '@/components/common/Button.vue';
import { useI18n } from 'vue-i18n';

const store = useStore();
const route = useRoute();
const router = useRouter();
const { t } = useI18n();

// axios通信処理待機フラグ
const isAxiosWait = ref(false);

// プレビュー可視状態
const isFullScreenPreviewMode = ref(false);

// コンテンツID
const contentId = ref(route.params.contentId);

// コンテンツ詳細情報
const contentDetail = ref([]);

// 全画面プレビューでGIFアニメを表示するためのタイムスタンプ
const timestamp = ref(0);

// 編集中フラグ
const isEditing = ref(false);

// 編集中テキスト
const editingNote = ref('');

// 編集中テロップ文字色
const editingCaptionColor = ref('');

// 編集中素材データ
const editingContentMaterialList = ref([]);

// 編集中フレーム
const editingFrame = ref({});

// テロップ読み上げ要否
const isCaptionSpeech = ref(false);

// コンテンツ詳細情報(初期表示時)
const initContentDetail = ref([]);

// テロップ画像化用のキャンバス
const canvas = ref('');

// ルートのクエリパラメータを監視
watch(
  () => route.query.edit,
  (editQuery) => {
    isEditing.value = editQuery === 'true';
  }
);

// isFullScreenPreviewModeの監視
watch(isFullScreenPreviewMode, () => {
  if (isFullScreenPreviewMode.value) {
    disableScroll();
  } else {
    enableScroll();
  }
});

// contentFrameの監視
watch(
  editingFrame,
  (contentFrame) => {
    editingFrame.value = contentFrame; // 新しい値を編集フレームに格納
  },
  { deep: true }
);

/**
 * contenetDetailからテロップ読み上げ要否を取得する
 */
const getIsCaptionSpeech = (contentDetailParam) => {
  return Boolean(contentDetailParam.contentCaptionUrl.length);
};

/**
 * 読み上げtrueにする&テロップ未入力の場合は読み上げをfalseのままにする
 * それ以外は引数のデータで読み上げ要否変数を更新する
 */
const changeIsCaptionSpeech = (isCaptionSpeechParam) => {
  if (isCaptionSpeechParam && editingNote.value.length === 0) return;
  isCaptionSpeech.value = isCaptionSpeechParam;
};

/**
 * テロップ文字色をセットする処理
 */
const selectContentCaptionColor = (selectContentCaptionColorParam) => {
  editingCaptionColor.value = selectContentCaptionColorParam;
  store.commit('content/setContentCaptionColor', editingCaptionColor.value);
};

// 編集保存ボタン活性判定処理：以下の変更を検知した場合に保存ボタンが活性化される
// テロップ文言・テロップ文字色・マテリアルの移動拡大縮小・動画音声ON/OFF
// フレーム情報・テロップ読み上げ
const isSaveButtonDisable = computed(() => {
  return (
    editingNote.value === contentDetail.value.contentCaption &&
    editingCaptionColor.value === contentDetail.value.contentCaptionColor &&
    JSON.stringify(editingContentMaterialList.value) === JSON.stringify(initContentDetail.value) &&
    editingFrame.value.frameId === contentDetail.value.contentFrameDto.frameId &&
    isCaptionSpeech.value === getIsCaptionSpeech(contentDetail.value)
  );
});

/**
 * クリックして選択したフレーム情報を更新
 */
const handleSelectFrame = (frame) => {
  editingFrame.value = frame;
  store.commit('content/setContentFrame', frame);
};

/**
 * テロップ文字色取得
 */
const contentCaptionColor = computed(() => {
  return store.getters['content/getContentCaptionColor'];
});

/**
 * テンプレートID取得
 */
const templateId = computed(() => {
  return store.getters['content/getTemplateId'];
});

/**
 * コンテンツのフレーム情報取得
 */
const contentFrame = computed(() => {
  return store.getters['content/getContentFrame'];
});

/**
 * コンテンツ詳細情報取得処理
 */
const getContentDetail = async (contentIdParam) => {
  contentDetail.value = await dataFetchContentDetail(contentIdParam);
  isCaptionSpeech.value = getIsCaptionSpeech(contentDetail.value);
};

/**
 * コンテンツ編集用の情報をStoreに格納する
 */
const setStoreContentDetail = () => {
  store.commit('content/setTemplateId', contentDetail.value.templateId);
  store.commit('content/setContentMaterialList', contentDetail.value.contentMaterialList);
  store.commit('content/setContentCaption', contentDetail.value.contentCaption);
  store.commit('content/setContentFrame', contentDetail.value.contentFrameDto);
  store.commit('content/setContentCaptionColor', contentDetail.value.contentCaptionColor);
};

const initialValue = async () => {
  await getContentDetail(contentId.value);
  isEditing.value = route.query.edit === 'true';

  // 編集中ならストアからデータを取得、未編集ならストアにデータを格納
  if (isEditing.value) {
    editingContentMaterialList.value = store.getters['content/getContentMaterialList'];
    // 既存のテロップを編集用変数に格納する
    editingNote.value = store.getters['content/getContentCaption'];
    // 既存のテロップ文字色を編集用変数に格納する
    editingCaptionColor.value = store.getters['content/getContentCaptionColor'];
    // 既存のフレームを編集用変数に格納する
    editingFrame.value = store.getters['content/getContentFrame'];
  } else {
    setStoreContentDetail();
    editingContentMaterialList.value = contentDetail.value.contentMaterialList;
    initContentDetail.value = JSON.parse(JSON.stringify(contentDetail.value.contentMaterialList));
    // 既存のテロップを編集用変数に格納する
    editingNote.value = contentDetail.value.contentCaption;
    // 既存のフレームを編集用変数に格納する
    editingFrame.value = contentDetail.value.contentFrameDto;
    isCaptionSpeech.value = getIsCaptionSpeech(contentDetail.value);
    // 既存の選択カラーを編集用変数に格納する
    editingCaptionColor.value = contentDetail.value.contentCaptionColor;
  }
};

/**
 * 改行の削除処理
 */
const removeLine = () => {
  editingNote.value = editingNote.value.replace('\n', '');
};

/**
 * 全画面プレビュー表示処理
 */
const showIsFullScreenPreviewMode = () => {
  removeLine();
  timestamp.value = new Date().getTime();
  isFullScreenPreviewMode.value = !isFullScreenPreviewMode.value;
};

/**
 * キャプション編集モード表示処理
 */
const showEditMode = async () => {
  // コンテンツ編集開始可否メッセージ出力
  try {
    await onsConfirm(t('message.SIGNAGE005I'));
    // 処理承認メッセージにて「OK」押下時にコンテンツの編集画面へ遷移
    await router.replace({
      name: 'ja-content-detail',
      params: { id: contentId.value }, // contentIdをparamsに渡す
      query: { edit: 'true' },
    });
    setStoreContentDetail();
  } catch {
    // 処理承認メッセージにて「いいえ」押下時、前の画面へ遷移
    router.back();
  }
};

/**
 * キャンセルボタン押下処理
 */
const moveContentDetail = () => {
  // コンテンツ詳細画面に遷移
  router.replace({
    name: 'ja-content-detail',
    params: { id: contentId.value }, // contentIdをparamsに渡す
    query: { edit: 'false' },
  });

  // 編集内容を元のコンテンツ詳細に戻す
  editingNote.value = contentDetail.value.contentCaption;
  editingCaptionColor.value = contentDetail.value.contentCaptionColor;
  editingContentMaterialList.value = contentDetail.value.contentMaterialList;
  editingFrame.value = contentDetail.value.contentFrameDto;
  isCaptionSpeech.value = getIsCaptionSpeech(contentDetail.value);

  // ストアにフレーム情報を更新
  store.commit('content/setContentFrame', contentDetail.value.contentFrameDto);
};

/**
 * 素材選択処理
 */
const clickMaterial = (materialNum) => {
  // 編集ノートとキャプション色をストアに保存
  store.commit('content/setContentCaption', editingNote.value);
  store.commit('content/setContentCaptionColor', editingCaptionColor.value);

  // 次の画面に遷移
  router.push({
    name: 'ja-content-image-resize',
    params: {
      materialNum,
    },
  });
};

/**
 * コンテンツアップロード処理
 */
const contentUpload = async () => {
  // ネットワークチェックし、エラー場合は後続処理をスキップ
  try {
    await checkNetwork();
  } catch {
    return;
  }

  // コンテンツ編集処理開始メッセージ出力
  await onsNotification(t('message.SIGNAGE006I'));

  let contentCaptionPngUrl = '';

  // テロップ入力時のみテロップ画像作成
  if (editingNote.value) {
    // テロップ画像作成処理呼び出し
    const contentCaptionPng = await createContentCaptionPng(
      canvas.value,
      editingNote.value,
      editingCaptionColor.value
    );
    contentCaptionPngUrl = contentDetail.value.contentCaptionPngUrl || `${createUuid()}.png`;

    // テロップ画像Blob登録処理
    await uploadContentCaptionPngBlobStorage(contentCaptionPng, contentCaptionPngUrl);
  }

  const contentParameters = new FormData();
  contentParameters.append('userId', store.getters['userInformation/getUserId']);
  contentParameters.append('contentId', contentId.value);
  contentParameters.append('contentCaption', editingNote.value);
  contentParameters.append('contentCaptionPngUrl', contentCaptionPngUrl);
  contentParameters.append('contentCaptionColor', editingCaptionColor.value);
  contentParameters.append('isCaptionSpeech', Number(isCaptionSpeech.value && !!editingNote.value));

  // マテリアル情報をパラメータに追加
  const contentMaterialUploadList = store.getters['content/getContentMaterialList'];
  contentMaterialUploadList.forEach((material, index) => {
    contentParameters.append(`contentInformationList[${index}].offsetX`, material.offsetX);
    contentParameters.append(`contentInformationList[${index}].offsetY`, material.offsetY);
    contentParameters.append(`contentInformationList[${index}].scale`, material.scale);
    contentParameters.append(
      `contentInformationList[${index}].isAudioEnabled`,
      Number(material.isAudioEnabled)
    );
    contentParameters.append(`materialIdList[${index}]`, material.materialId);
  });

  // フレーム情報をパラメータに追加
  const contentUploadFrame = store.getters['content/getContentFrame'];
  contentParameters.append('frameId', contentUploadFrame.frameId);

  // ボタン連打回避のためフラグ設定
  isAxiosWait.value = true;

  // コンテンツ登録API呼び出し
  try {
    await axios.put('/content', contentParameters, {
      headers: { Authorization: localStorage.getItem('token') },
    });

    // テロップ文言が空になった場合はBlobからテロップ画像を削除
    if (contentDetail.value.contentCaption !== '' && editingNote.value === '') {
      deleteContentCaptionPngBlobStorage(contentDetail.value.contentCaptionPngUrl);
    }

    // キャプション変更成功時、配信グループ管理画面へ遷移
    router.push({ name: 'ja-stream-group-wrapper' });
  } catch (error) {
    // Axios共通エラーハンドリング処理をCall
    handleAxiosCommonException(error);
  } finally {
    isAxiosWait.value = false; // Axios待機フラグを解除
  }
};

/**
 * もっと見るボタン押下処理
 */
const showMoreFrame = () => {
  removeLine();
  store.commit('content/setContentCaption', editingNote.value);
  store.commit('content/setContentCaptionColor', editingCaptionColor.value);
  router.push('/ja/content/frameSelect');
};

// 入力値から改行を削除して入力文字数を返す処理
const calcLength = () => {
  removeLine();
  return editingNote.value.length;
};

// onMounted フック
onMounted(async () => {
  await initialValue();
  canvas.value = document.getElementById('canvas');
});

// onUnmounted フック
onUnmounted(() => {
  document.getElementById('content-preview-full-screen-modal')?.remove();
});
</script>

<style scoped>
.ja-content-detail {
  margin: auto;
}
.header-back-button {
  background: transparent;
  border: #fff;
  color: #aaaaaa;
  font-size: 4rem;
  left: 2rem;
  position: absolute;
}

.modal-close-mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: inherit;
  border: none;
}

.modal-wrapper .preview-area {
  text-align: left;
}

.content-detail-area {
  box-sizing: border-box;
  background-color: #fff;
  margin: auto;
  padding-top: 10vh;
  padding-top: 10dvh;
  padding-bottom: 10vh;
  padding-bottom: 10dvh;
  z-index: 1;
}

.content-element-area {
  width: 90%;
  margin: 2rem auto;
}

.content-preview-button {
  margin: auto;
}

label {
  display: block;
  font-size: 1.3rem;
  margin-bottom: 1.5rem;
}

p {
  font-size: 1.5rem;
  margin: 0;
}

.content-caption-detail-area {
  font-size: 1.5rem;
  white-space: pre-line;
  word-break: break-all;
}

.content-caption-area {
  position: relative;
  background-color: #fff;
  height: 20vh;
  width: 100%;
  z-index: 1;
}

.caption-color-label.isEditting {
  display: none;
}

.ja-content-caption-color-area {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.ja-content-caption-color-area.isNotEditting {
  justify-content: left;
  align-items: center;
}

.ja-content-caption-color-cell {
  margin: 0.5rem;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid black;
}

.ja-content-caption-color-cell.isSelected {
  border: 5px solid green;
}
.ja-content-caption-color-cell.isNotEditting {
  border: 1px solid black;
  width: 20px;
  height: 20px;
}

.ja-content-caption-color-cell.unSelectColor {
  display: none;
}

.text-area {
  position: absolute;
  height: 100%;
  width: 100%;
  padding: 1rem;
  border: solid#aaaaaa;
  font-size: 2rem;
  resize: none;
  box-sizing: border-box;
}

.template-title {
  color: black;
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
}

.template-description {
  color: black;
  font-size: 1.3rem;
  line-height: 1.5rem;
  margin: 0;
  width: 100%;
  white-space: pre-line;
}

.template-element-size {
  box-sizing: border-box;
  height: 11rem;
  width: 100%;
}

.template-image {
  padding: 2rem;
  vertical-align: middle;
  height: 11rem;
  object-fit: contain;
}

.template-text-area {
  padding: 5% 0;
  text-align: left;
}

.caption-count {
  color: #aaaaaa;
  text-align: right;
  padding: 1rem 0 0 0;
}

.preview-description {
  font-size: 1.4rem;
  margin-top: 10px;
  text-align: center;
}

.modal-wrapper .preview-area {
  text-align: left;
}

.modal-wrapper {
  height: 100vh;
  height: 100dvh;
}

.modal-close-button-area {
  height: 4rem;
  position: absolute;
  right: 3%;
  top: 3%;
  width: 4rem;
  z-index: 1;
}

.modal-close-button,
.modal-close-button:active {
  align-items: center;
  background-color: #222222;
  border-radius: 50%;
  display: flex;
  height: 100%;
  justify-content: center;
  padding: 0;
  width: 100%;
}

.modal-close-icon {
  font-size: 2.5rem;
  margin: auto;
}

.footer-button-area {
  width: 90%;
}

.footer-back-button {
  background: #fff;
  border: solid 1px #cccccc;
  color: #222222;
  margin: auto;
  padding: 1rem 0;
  text-align: center;
  width: 35%;
  height: 5.5rem;
}

.footer-upload-button {
  box-shadow: 0rem 0.2rem #21963b;
  color: #fff;
  margin: auto;
  padding: 1rem 0;
  text-align: center;
  width: 55%;
  overflow: visible;
  height: 5.5rem;
}

.edit-caption-label {
  display: none;
}

.common-footer {
  height: auto;
  padding-block: 2rem;
}

.footer-button {
  background: #fff;
  border: solid 1px #cccccc;
  margin: auto;
  padding: 1rem 0;
  text-align: center;
  color: #222222;
}

.footer-button:hover,
.footer-back-button:hover,
.footer-upload-button:hover {
  opacity: 0.8;
}

@media screen and (min-width: 840px) {
  .content-element-area {
    width: 100%;
  }
}

.canvas {
  visibility: hidden;
}
</style>
